import { EventEmitter, Injectable, signal } from '@angular/core';
import { IMenuItem } from '../../layout/components/sidebar/option-a/sidebar/models/menu-item.model';
import { LayoutService } from './layout.service';

@Injectable({
    providedIn: 'root'
})
export class SidebarService {
    private _sidebarMenuItems: IMenuItem[] = [];
    public sideBarVisibility = signal<boolean>(true)
    onChange: EventEmitter<any> = new EventEmitter<any>();

    set sidebarMenuItems(val: IMenuItem[]) {
        this._sidebarMenuItems = val;
        this.onChange.next(val);
    }

    get sidebarMenuItems(): IMenuItem[] {
        return this._sidebarMenuItems;
    }

    constructor(public layoutService: LayoutService) { }

    setSidebarData(items: IMenuItem[] = []): void {
        if (items.length > 0) {
            this.initializeMenu(items);
        }
        
    }

     
    clearSideBarData() {
        this.sidebarMenuItems = [];
    }

    initializeMenu(menuItems: IMenuItem[]) {
        this.sidebarMenuItems = menuItems;
    }
}
